import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const RoundsModelSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    account: z.string().nullish(),
    funding_stage: z.string().nullish(),
    currency: z.string().nullish(),
    raise_amount: z.number().nullish(),
    pre_money_valuation: z.number().nullish(),
    post_money_valuation: z.number().nullish(),
    security_type: z.string().nullish(),
    round_close_date: z.string().nullish(),
    parent_id: z.string().nullish(),
    initial_close_amount: z.number().nullish(),
    // Instrument terms for SAFE / convertible rounds (Phase 2)
    valuation_cap: z.number().nullish(),
    conversion_discount: z.number().nullish(),
    interest_rate: z.number().nullish(),
    maturity_date: z.string().nullish(),
    mfn: z.boolean().nullish(),
    // Per-share issue price of the primary instrument (share/warrant types)
    issue_price: z.number().nullish()
  })
  .strict()

export const RoundsModelFields = makeFieldKeys(RoundsModelSchema)

export type RoundsModel = z.infer<typeof RoundsModelSchema>

function validateRoundsModel(data: unknown): RoundsModel {
  try {
    return validateWithZodSchema(RoundsModelSchema, data, 'rounds model')
  } catch (error) {
    throw new Error(`Rounds model validation failed: ${error}`)
  }
}
